// extracted by mini-css-extract-plugin
var _1 = "styles-module__noMessage___jy6fl";
export { _1 as "noMessage" }
